module.exports = __webpack_public_path__ + "img/menu-trigger-bar.b518edb4.svg";